import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import { Icon } from '@/components';
import { cn } from '@/utils';

interface AccountLevel {
  title: string;
  description: string;
  isChecked: boolean;
}

interface VerificationAccountLevelsProps {
  isVerified?: boolean;
  className?: string;
}
export const VerificationAccountLevels: FC<VerificationAccountLevelsProps> = ({
  isVerified,
  className,
}) => {
  const { t } = useTranslation();

  const ACCOUNT_LEVELS: AccountLevel[] = [
    {
      title: t('verification.levels.basic.title'),
      description: t('verification.levels.basic.description'),
      isChecked: true,
    },
    {
      title: t('verification.levels.verified.title'),
      description: t('verification.levels.verified.description'),
      isChecked: !!isVerified,
    },
  ];

  return (
    <div className={cn(className)}>
      <p className="h5 text-blue-900">{t('verification.account_levels')}</p>
      <div className="flex flex-col gap-[18px] divide-y divide-blue-150 border-b border-blue-150 pb-[18px]">
        {ACCOUNT_LEVELS.map((level) => {
          return (
            <div key={level.title} className="flex gap-2 pt-[18px]">
              <Icon
                name="checkmarkCircled"
                className={cn(
                  'mt-1 h-5 w-5 rounded-full shrink-0',
                  level.isChecked ? 'text-green-500' : 'text-grey-300',
                )}
              />
              <div>
                <p className="body2 text-blue-900">{level.title}</p>
                <p className="body2 mt-1 text-grey-600">{level.description}</p>
              </div>
            </div>
          );
        })}
        {/* <div className="pt-[18px]"> */}
        {/*  <Link href="/" className="text-blue-500"> */}
        {/*    {t('profile.faq_verification')} */}
        {/*  </Link> */}
        {/* </div> */}
      </div>
    </div>
  );
};
